export function LogoIcon({ mainClassName, fillClassName }) {
    return (
        <svg
            width={137}
            height={46}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 137 46"
        >
            <path
                className={fillClassName}
                fill="#fff"
                fillRule="evenodd"
                d="M64.664.043c-.04.052-.03.386.026.886.304 2.69.308 2.897.31 18.36.002 13.46-.008 14.784-.112 15.131-.418 1.394-1.834 2.308-3.446 2.225-.479-.025-.664.132-.54.457.063.164 10.705.174 10.768.01.11-.288-.078-.492-.435-.47-1.746.104-3.24-.885-3.615-2.393-.27-1.087-.174-26.387.099-26.082.134.151 1.013 1.09 1.953 2.087 1.538 1.63 5.228 5.559 6.318 6.725l2.164 2.306c3.968 4.223 4.793 5.103 5.687 6.064.517.556 1.52 1.623 2.23 2.373s1.714 1.819 2.231 2.375 1.46 1.561 2.095 2.233 1.624 1.724 2.197 2.337c3.73 3.997 3.727 3.995 3.553 2.428-.349-3.14-.333-2.339-.359-17.974-.025-15.578-.035-15.116.327-15.854.574-1.172 1.44-1.695 2.929-1.77.916-.047 1.103-.152.956-.535-.08-.211-10.776-.145-10.83.067-.1.399-.031.435.897.476 1.568.07 2.535.722 3.06 2.06.238.608.26 26.518.022 26.331-.08-.062-.423-.411-.764-.776-.785-.842-3.97-4.24-6.768-7.22-1.19-1.268-2.822-3.011-3.627-3.875a860 860 0 0 0-3.004-3.21c-.305-.326-.823-.875-1.15-1.22a344 344 0 0 1-1.505-1.606 1999 1999 0 0 0-4.15-4.437l-2.024-2.159c-.631-.672-1.97-2.101-2.974-3.175S65.289.226 65.207.176c-.286-.174-.475-.22-.543-.133M39.916.086c-.022.035-.087.312-.145.616-.117.616-.749 2.714-.914 3.033-.103.2-.087.255.523 1.857.346.909.798 2.108 1.005 2.664.352.947 1.243 3.313 2.666 7.083A14710.996 14710.996 0 0 0 46.958 25.7a885 885 0 0 1 1.57 4.187 248 248 0 0 0 .894 2.378c.706 1.843.786 2.288.535 2.983-.308.856-1.185 1.407-2.236 1.407-.27 0-.349.108-.28.384.06.239 11.631.284 11.758.046.133-.248.017-.43-.273-.43-2.329 0-3.873-1.319-5.148-4.396-.23-.556-2.09-5.015-4.132-9.908a16783 16783 0 0 1-6.328-15.177c-.48-1.152-1.141-2.738-1.47-3.524C40.522.463 40.508.43 40.276.179c-.15-.164-.293-.201-.36-.093M9.038.168C3.586.693-.01 5.452 1.082 10.698c.508 2.44 1.194 3.404 4.738 6.667a2266 2266 0 0 1 6.596 6.11c2.793 2.596 3.545 4.18 3.207 6.758C14.416 39.45.53 37.65 1.313 28.376c.069-.806-.415-.843-.661-.05-.7 2.252-.885 6.3-.317 6.927 2.393 2.645 9.772 3.552 13.549 1.667 5.379-2.686 6.687-10.848 2.395-14.953-.28-.269-.935-.881-1.453-1.36a1041 1041 0 0 1-2.338-2.166l-.942-.873c-.21-.197-1.06-.983-1.888-1.747-4.43-4.093-4.442-4.104-4.99-5.142C2.08 5.773 6.609.527 12.116 2.053c2.194.608 3.897 2.62 3.897 4.604 0 .369.167.578.43.54.165-.023.31-6.477.145-6.477-.392 0-2.101-.083-2.18-.106-.29-.085-2.523-.384-3.346-.448C10.03.085 9.9.085 9.038.168M129.876.84c-4.378.02-4.378.02-4.42.187-.085.34.053.438.658.473 1.134.066 1.955.804 2.081 1.871.083.699.102.662-3.799 7.466a679.96 679.96 0 0 1-2.34 4.117 227 227 0 0 0-1.848 3.28c-.486.917-.378.979-1.289-.745-.442-.838-1.008-1.9-1.256-2.36a939 939 0 0 1-1.589-2.966l-1.676-3.14c-.297-.557-.929-1.734-1.404-2.617-1.148-2.131-1.205-2.267-1.199-2.826.013-1.2.826-2.022 2.059-2.08.608-.03.853-.245.651-.573-.173-.28-12.951-.055-12.93.228.021.297.021.297.808.342 1.782.104 3.101.698 4.342 1.956.506.512.666.76 2.806 4.336 1.037 1.734 3.235 5.406 4.885 8.16 2.83 4.727 4.174 13.252 2.875 18.238-.375 1.44-1.631 2.396-3.188 2.423-.604.01-.788.149-.657.49.044.116 11.087.184 11.381.071.364-.14.056-.588-.381-.554-1.261.099-2.623-.689-3.214-1.86-.619-1.226-.488-13.483.154-14.502.52-.825.931-1.486 2.382-3.84.557-.904 1.382-2.238 1.834-2.965s1.025-1.652 1.274-2.055l1.082-1.744.91-1.466c.154-.25.38-.61.502-.802s.45-.726.731-1.186c1.32-2.17 1.74-2.701 2.733-3.45 1.079-.815 2.072-1.184 3.373-1.254.767-.041.767-.041.789-.304.032-.38.038-.38-7.12-.349M37.004 7.087a85 85 0 0 1-1.093 2.25c-.515 1.037-1.415 2.858-2 4.048-.584 1.19-2.311 4.69-3.838 7.78-6.853 13.872-7.641 15.478-7.641 15.567 0 .035.263.064.584.064 1.558 0 2.934.696 3.932 1.987.215.278.215.278.44-.453.271-.887 1.159-3.721 2.01-6.419l1.371-4.36c.41-1.306.929-2.954 1.154-3.664s.758-2.406 1.185-3.768c.427-1.363.96-3.058 1.185-3.768.224-.71.759-2.406 1.187-3.769a588 588 0 0 1 1.297-4.072c.285-.878.518-1.64.518-1.692 0-.211-.144-.078-.29.27M22.077 37.97c-3.557.929-3.477 6.171.108 7.092 1.482.381 3.38-.393 4.015-1.637.142-.28.142-.28 1.345-.284.661-.003 1.28-.015 1.376-.027s1.321-.042 2.722-.067c1.4-.025 2.86-.06 3.245-.076.383-.016 1.592-.047 2.686-.068 1.094-.02 2.601-.054 3.35-.074.748-.02 3.386-.082 5.86-.137a6563 6563 0 0 0 13.678-.315l7.396-.173c2.437-.058 6.472-.151 8.967-.208s5.18-.12 5.966-.14 3.079-.07 5.094-.108 3.757-.084 3.872-.1c.116-.017 1.199-.052 2.408-.078 1.209-.025 2.211-.058 2.227-.073.093-.084-.437-.104-4.362-.165a445 445 0 0 1-6.308-.136 474 474 0 0 0-6.14-.142c-2.284-.04-4.42-.089-4.746-.109s-2.304-.067-4.396-.105a847 847 0 0 1-6.28-.136c-1.363-.038-3.937-.1-5.722-.14-1.785-.039-4.564-.102-6.175-.14a1862 1862 0 0 0-4.78-.106c-1.017-.02-3.011-.068-4.431-.105s-3.964-.098-5.652-.136l-6.35-.144-3.977-.09c-.696-.017-.696-.017-.855-.258-.913-1.387-2.557-2.028-4.14-1.615m1.68 2.587c.694.557.667 1.42-.058 1.924-.546.38-1.206.237-1.608-.35-.728-1.062.665-2.38 1.667-1.574"
                clipRule="evenodd"
            />
        </svg>
    );
}


export function HeaderMenuArrowIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={12}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 12 12"
        >
            <path
                d="M2 8l4-4 4 4"
                stroke="#fff"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}

export function HomeIcon({
    mainClassName,
    fillClassName,
}) {
    return (
        <svg
            width={20}
            height={20}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 20 20"
        >
            <path
                d="M11.931 16.532v-4.859a.572.572 0 00-.155-.419.553.553 0 00-.412-.157H8.636a.578.578 0 00-.42.157.572.572 0 00-.155.42v4.858h3.87zm-8.543-.254v-5.705L9.55 5.324c.3-.26.602-.26.907 0l6.162 5.249v5.705c0 .539-.157.96-.472 1.265-.314.305-.742.457-1.282.457H5.143c-.546 0-.976-.152-1.29-.457-.31-.304-.465-.726-.465-1.265zM1 9.547c0-.23.096-.427.287-.591l7.681-6.552c.32-.27.666-.404 1.04-.404.373 0 .717.135 1.031.404l7.673 6.552c.192.16.288.364.288.613a.632.632 0 01-.221.51.777.777 0 01-.53.187.681.681 0 01-.325-.083 1.907 1.907 0 01-.288-.187L10.324 3.76a.481.481 0 00-.317-.134.481.481 0 00-.317.134L2.371 9.996c-.093.07-.192.133-.295.187a.64.64 0 01-.317.083c-.236 0-.422-.07-.56-.21A.73.73 0 011 9.547zm13.555-3.631V4.08c0-.164.05-.297.148-.396a.534.534 0 01.398-.158h.995a.52.52 0 01.545.554v3.617l-2.086-1.782z"
                fill="#E4E6EA"
                className={fillClassName}
            />
        </svg>
    );
}

export function AccountIcon({ mainClassName, strokeClassName }) {
    return (
        <svg
            width={22}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 22 22"
        >
            <path
                d="M11 12.833a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z"
                stroke="#505A72"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
            <path
                d="M11 19.708a8.708 8.708 0 100-17.416 8.708 8.708 0 000 17.416z"
                stroke="#505A72"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
            <path
                d="M16.348 17.863a3.198 3.198 0 00-3.056-2.28H8.709a3.198 3.198 0 00-3.056 2.28"
                stroke="#505A72"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}


export function SelectedTickIcon({
    mainClassName,
    strokeClassName,
}) {
    return (
        <svg
            width={14}
            height={14}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 14 14"
        >
            <path
                d="M2 6.348l3.499 3.514a.2.2 0 00.279.004L12 4"
                stroke="#505A72"
                strokeWidth={2}
                strokeLinecap="round"
                className={strokeClassName}
            />
        </svg>
    );
}

export function LogoutIcon({
    mainClassName,
    strokeClassName,
}) {
    return (
        <svg
            width={22}
            height={22}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={mainClassName}
            viewBox="0 0 22 22"
        >
            <path
                d="M10.083 17.776V6.878c0-.633-.325-1.22-.861-1.555L5.555 3.031C4.334 2.27 2.75 3.146 2.75 4.586v10.897c0 .633.325 1.22.862 1.555l3.666 2.292c1.221.763 2.805-.115 2.805-1.554zM13.75 10.083h5.5M17.416 11.917l1.834-1.834-1.834-1.833M10.084 17.417h3.666c1.013 0 1.834-.82 1.834-1.834v-.916"
                stroke="#505A72"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
            <path
                d="M15.584 5.5v-.917c0-1.013-.82-1.833-1.834-1.833H4.584"
                stroke="#505A72"
                strokeWidth={1.2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={strokeClassName}
            />
        </svg>
    );
}
